import { useHistory, useLocation } from "react-router-dom";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../../Config/firebase";
import "../Navbar/navbar.css";
import React, { useEffect, useState, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import {
  collection,
  query,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import PesquisaPendenteAviso from "../../KPIs/PesquisaPendenteAviso";
import { getUsuarioAtualComTenant, tenantWhere } from "../../Utils/tenant";
import { LOGO_NAVEGACAO } from "../../Config/branding";
import LogoRelatorio from "../LogoRelatorio/LogoRelatorio";

function NavbarCliente() {
  const history = useHistory();
  const location = useLocation();

  const [usuario, setUsuario] = useState(null);
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [perfilUsuario, setPerfilUsuario] = useState({ tipo: "cliente", email: "" });
  const [openPesquisa, setOpenPesquisa] = useState(false);
  const [kpis, setKpis] = useState([]);
  const [openEnsaios, setOpenEnsaios] = useState(false);
const navbarRef = useRef(null);
  /* =========================
     USUÁRIO LOGADO
  ========================= */
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUsuario(user || null);

      if (!user) return;

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          const dados = snap.data();
          setNomeUsuario(dados.nome || dados.nomeCompleto || "Usuário");
          setPerfilUsuario({
            tipo: dados.tipo || "cliente",
            email: dados.email || user.email || "",
          });
        } else {
          setNomeUsuario("Usuário");
          setPerfilUsuario({ tipo: "cliente", email: user.email || "" });
        }
      } catch (e) {
        console.error("Erro ao buscar nome do usuário", e);
        setNomeUsuario("Usuário");
      }
    });

    return () => unsubscribe();
  }, []);

  /* =========================
     KPIs (CLIENTE)
  ========================= */
  useEffect(() => {
    let cancelado = false;

    async function carregarKPIs() {
      try {
        const usuarioTenant = await getUsuarioAtualComTenant();
        const q = query(
          collection(db, "kpis"),
          ...tenantWhere(usuarioTenant)
        );

        const snap = await getDocs(q);
        if (cancelado) return;

        setKpis(
          snap.docs
            .map(d => ({ id: d.id, ...d.data() }))
            .filter(kpi => kpi.ativo === true && kpi.escopo === "cliente")
        );
      } catch (error) {
        console.error("Erro ao carregar pesquisas do cliente:", error);
        if (!cancelado) setKpis([]);
      }
    }

    carregarKPIs();
    return () => {
      cancelado = true;
    };
  }, []);
useEffect(() => {
  function handleClickOutside(event) {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setOpenPesquisa(false);
      setOpenEnsaios(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
  async function sair() {
    await signOut(auth);
    sessionStorage.clear();
    localStorage.clear();
    history.push("/app");
  }

  return (
    <>
    <PesquisaPendenteAviso tipoUsuario="cliente" />
    <nav
  ref={navbarRef}
  className="navbar navbar-expand-md navbar-default fixed-top"
>
      <div className="container-fluid">
        <div className="navbar-brand d-flex align-items-center">
              <LogoRelatorio
                logoPadrao={LOGO_NAVEGACAO}
                monocromaticaBranca
                alt="Logo"
                style={{ height: 40 }}
              />
            </div>


        <button
          className="navbar-toggler ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCliente"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarCliente">
          <ul className="navbar-nav me-auto align-items-center">
            <li className="nav-item">
              <button
                className={`nav-link btn btn-link ${
                  location.pathname === "/app/laudos" ? "active" : ""
                }`}
                onClick={() => history.push("/app/laudos")}
              >
                Página Principal
              </button>
            </li>

            <li className="nav-item position-relative">
  <button
    className="nav-link btn btn-link d-flex align-items-center gap-1"
    onClick={() => {
      setOpenPesquisa(p => !p);
      setOpenEnsaios(false);
    }}
  >
    Pesquisa
    {openPesquisa ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </button>

  {openPesquisa && (
    <ul className="dropdown-menu show mt-1 position-absolute">
      {kpis.map(kpi => (
        <li key={kpi.id}>
          <button
            className="dropdown-item"
            onClick={() => {
              setOpenPesquisa(false);
              history.push(`/app/pesquisa/${kpi.id}`);
            }}
          >
            {kpi.nome}
          </button>
        </li>
      ))}
    </ul>
  )}
</li>

<li className="nav-item position-relative">
  <button
    className="nav-link btn btn-link d-flex align-items-center gap-1"
    onClick={() => {
      setOpenEnsaios(e => !e);
      setOpenPesquisa(false);
    }}
  >
    Ensaios
    {openEnsaios ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </button>

  {openEnsaios && (
    <ul className="dropdown-menu show mt-1 position-absolute">
      <li>
        <button
          className="dropdown-item"
          onClick={() => {
            setOpenEnsaios(false);
            history.push("/app/ensaio-raa");
          }}
        >
          Ensaios RAA
        </button>
      </li>
      <li>
        <button
          className="dropdown-item"
          onClick={() => {
            setOpenEnsaios(false);
            history.push("/app/cimento-consistencia-pega");
          }}
        >
          Ensaios de Consistência
        </button>
      </li>
    </ul>
  )}
</li>

            <li className="nav-item">
              <button className="nav-link btn btn-link" onClick={sair}>
                Sair
              </button>
            </li>
          </ul>

          {usuario && (
            <div
              className="usuario-logado ms-auto"
              title={`Tipo: ${perfilUsuario.tipo ? perfilUsuario.tipo.charAt(0).toUpperCase() + perfilUsuario.tipo.slice(1) : "Não informado"}\nE-mail: ${perfilUsuario.email || usuario.email || "Não informado"}`}
              style={{ cursor: "help" }}
              aria-label={`Usuário ${perfilUsuario.tipo || "não informado"}, e-mail ${perfilUsuario.email || usuario.email || "não informado"}`}
            >
              <span className="texto-usuario-logado">{nomeUsuario}</span>
              <img src="/Images/perfil.png" className="imgUsuario" alt="Usuário" />
            </div>
          )}
        </div>
      </div>
    </nav>
    <div className="navbar-page-spacer" aria-hidden="true" />
    </>
  );
}

export default NavbarCliente;
